import responseHandler from "../system/server-response-handler";
import { getRequest } from "../system/server-calls";

const COMMON_URL = "Countries";

//Getting all currencies
const getAllCurrencies = () => {
  return getRequest(`Currencies`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting all allowed countries
const getAllAllowedCountries = () => {
  return getRequest(`${COMMON_URL}/Allowed`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting all must have ammenities
const getAllMustHaveAmmenities = () => {
  return getRequest(`Amenities`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting all hobbies
const getAllHobbies = () => {
  return getRequest(`GetHobbies`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting all day to day activity
const getAllDayToDayActivity = () => {
  return getRequest(`GetDayToDay`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const homeService = {
  getAllHobbies,
  getAllCurrencies,
  getAllAllowedCountries,
  getAllDayToDayActivity,
  getAllMustHaveAmmenities,
};
